// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"384":"7be0a518","453":"0471fc82"}[chunkId] + ".chunk.js";
};